/**
 * Deep links are deterministic (spec §7): they need nothing from the sync, so every existing
 * customer's link can be generated before go-live. The base URL is a placeholder until the final
 * subdomain under gslapp.com is chosen.
 */
export const DEFAULT_APP_BASE_URL = 'https://files.gslapp.com';
/** Oracle account number = 20000 prefix + BisTrack customer code (spec §1). */
export const ORACLE_ACCOUNT_PREFIX = '20000';
export function oracleAccountNumberFromBisTrackCode(bisTrackCode) {
    const code = String(bisTrackCode).trim();
    if (!/^\d+$/.test(code))
        throw new Error(`BisTrack customer code must be numeric, got "${code}"`);
    return `${ORACLE_ACCOUNT_PREFIX}${code}`;
}
export const deepLink = {
    customer: (accountNumber, base = DEFAULT_APP_BASE_URL) => `${trimSlash(base)}/customers/${encodeURIComponent(accountNumber)}`,
    site: (siteId, base = DEFAULT_APP_BASE_URL) => `${trimSlash(base)}/jobs/${encodeURIComponent(String(siteId))}`,
    supplier: (supplierNumber, base = DEFAULT_APP_BASE_URL) => `${trimSlash(base)}/suppliers/${encodeURIComponent(supplierNumber)}`,
    document: (documentId, base = DEFAULT_APP_BASE_URL) => `${trimSlash(base)}/d/${encodeURIComponent(documentId)}`,
};
function trimSlash(s) {
    return s.endsWith('/') ? s.slice(0, -1) : s;
}
//# sourceMappingURL=deep-links.js.map